<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
  integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p" crossorigin="anonymous" />

<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>

<div class="validation-card-host">
<form [formGroup]="validationForm" *ngIf="isFormReady">

  <div class="vc-page">

    <!-- One consolidated console: record list on the left, the selected
         record's detail on the right, application actions pinned underneath. -->
    <div class="vc-shell">

      <!-- ================= PAGE HEADER ================= -->
      <header class="vc-header">

        <div class="vc-header-text">
          <h1 class="vc-title">{{custName}}</h1>
          <!-- No customer ID means no CBS record to quote, so the mobile the
               application came in on identifies the applicant instead. -->
          <p class="vc-subtitle" *ngIf="custId">Customer ID: {{custId}}</p>
          <p class="vc-subtitle" *ngIf="!custId">Mobile No: {{mobileNo || '-'}}</p>
        </div>

        <span *ngIf="isChecker && hasRecords()" class="vc-mode-chip">
          Checker Review &middot; Maker's actions are locked
        </span>

      </header>


      <!-- Load failed, or the application genuinely has nothing flagged -->
      <div *ngIf="!hasRecords()" class="vc-empty">
        No land records to review for this application.
      </div>


      <!-- ================= MASTER + DETAIL ================= -->
      <div *ngIf="hasRecords()" class="vc-body">

        <!-- ---------- MASTER: every land record ---------- -->
        <aside class="vc-list" role="tablist" aria-label="Land records">

          <button
            *ngFor="let applicant of getApplicants().controls; let i=index"
            type="button"
            role="tab"
            class="vc-list-item"
            [class.vc-list-item-active]="i === activeIndex"
            [class.vc-list-item-passed]="isReadOnlyRecord(i)"
            [class.vc-list-item-failed]="!isReadOnlyRecord(i)"
            [attr.aria-selected]="i === activeIndex"
            (click)="selectRecord(i)"
          >

            <!-- Whole name takes the pass/fail colour here — the split label /
                 value treatment belongs to the detail pane only. -->
            <span class="vc-list-name">
              Survey No {{applicant.get('Survey_No').value}}
            </span>

            <span class="vc-list-meta">
              Area {{applicant.get('Area').value}}
            </span>

            <span
              class="vc-chip vc-chip-sm"
              [class.vc-chip-approved]="recordState(i) === 'approved'"
              [class.vc-chip-rejected]="recordState(i) === 'rejected'"
              [class.vc-chip-pending]="recordState(i) === 'pending'"
              [class.vc-chip-success]="recordState(i) === 'success'"
            >
              <ng-container *ngIf="recordState(i) === 'approved'">Approved &#10003;</ng-container>
              <ng-container *ngIf="recordState(i) === 'rejected'">Rejected &#10007;</ng-container>
              <ng-container *ngIf="recordState(i) === 'pending'">Pending</ng-container>
              <ng-container *ngIf="recordState(i) === 'success'">Success &#10003;</ng-container>
            </span>

          </button>

        </aside>


        <!-- ---------- DETAIL: the selected record ----------
             Every record stays in the DOM (inactive ones are display:none, not
             *ngIf'd away) so their controls remain bound to the FormArray and
             nothing half-entered is lost by switching records. -->
        <div class="vc-detail" formArrayName="applicants">

          <section
            *ngFor="let applicant of getApplicants().controls; let i=index"
            [formGroupName]="i"
            class="vc-pane"
            [class.vc-pane-hidden]="i !== activeIndex"
            [class.vc-pane-passed]="isReadOnlyRecord(i)"
            [class.vc-pane-failed]="!isReadOnlyRecord(i)"
            role="tabpanel"
          >

            <!-- BRE-passed record: banner only, no controls below -->
            <div *ngIf="isReadOnlyRecord(i)" class="vc-passed-note">
              <span class="vc-chip vc-chip-success">Success &#10003;</span>
              <span>Verified — no action needed.</span>
            </div>

            <!-- ---------- RECORD HEAD ---------- -->
            <header class="vc-pane-head">

              <h2 class="vc-pane-title">
                Land Survey No
                <span class="vc-pane-title-value">{{applicant.get('Survey_No').value}}</span>
              </h2>

              <span class="vc-pane-area">
                Area {{applicant.get('Area').value}}
              </span>

            </header>

            <!-- Maker's and checker's verdicts on this record, side by side -->
            <div *ngIf="isChecker && !isReadOnlyRecord(i)" class="vc-verdicts">

              <div class="vc-verdict">
                <span class="vc-verdict-role">Maker</span>
                <span
                  *ngIf="applicant.get('decision').value === 'approved'"
                  class="vc-chip vc-chip-approved">
                  Approved &#10003;
                </span>
                <span
                  *ngIf="applicant.get('decision').value === 'rejected'"
                  class="vc-chip vc-chip-rejected">
                  Rejected &#10007;
                </span>
              </div>

              <div class="vc-verdict">
                <span class="vc-verdict-role">Checker</span>
                <span
                  *ngIf="applicant.get('checkerDecision').value === 'approved'"
                  class="vc-chip vc-chip-approved">
                  Approved &#10003;
                </span>
                <span
                  *ngIf="applicant.get('checkerDecision').value === 'rejected'"
                  class="vc-chip vc-chip-rejected">
                  Rejected &#10007;
                </span>
                <span
                  *ngIf="!applicant.get('checkerDecision').value"
                  class="vc-chip vc-chip-pending">
                  Pending
                </span>
              </div>

            </div>


            <!-- ================= CHECKS ================= -->
            <div formArrayName="Users" class="vc-checks">

              <section
                *ngFor="let user of getUsers(i).controls; let j=index"
                [formGroupName]="j"
                class="vc-check"
                [class.vc-check-failed]="user.get('failed').value"
              >

                <header class="vc-check-head">

                  <h3 class="vc-check-title">
                    {{user.get('label').value}} Check
                  </h3>

                  <span *ngIf="user.get('failed').value" class="vc-chip vc-chip-failed">
                    Failed &#10007;
                  </span>

                  <span *ngIf="!user.get('failed').value" class="vc-chip vc-chip-success">
                    Success &#10003;
                  </span>

                </header>


                <!-- FAILED CASE -->
                <div *ngIf="user.get('failed').value" class="vc-check-body">

                  <!-- NAME FAILED -->
                  <div *ngIf="user.get('Error').value==='name'" class="vc-compare">

                    <div class="vc-compare-item">
                      <span class="vc-compare-label">Name as per CBS</span>
                      <span class="vc-compare-value">{{user.get('cbsName').value}}</span>
                    </div>

                    <span class="vc-compare-sep">vs</span>

                    <div class="vc-compare-item">
                      <span class="vc-compare-label">Name as per Land</span>
                      <span class="vc-compare-value">{{user.get('name').value}}</span>
                    </div>

                  </div>


                  <!-- ============ MAKER'S OWN VIEW ============ -->
                  <ng-container *ngIf="!isChecker">

                    <div *ngIf="user.get('Error').value==='land'" class="vc-field">

                      <label class="vc-field-label">
                        Enter Land Area (in acres)
                      </label>

                      <input
                        class="vc-input"
                        type="text"
                        formControlName="enteredLandArea"
                        placeholder="e.g., 2.5"
                        maxlength="4"
                        (keypress)="allowOnlyNumberAndDecimal($event)"
                        (input)="validateLandAreaRange($event, user.get('enteredLandArea'))"
                      >

                    </div>

                    <label class="vc-confirm">

                      <input
                        type="checkbox"
                        class="vc-checkbox"
                        formControlName="isChecked"
                      >

                      <span>{{ getConfirmationText(user.get('label').value) }}</span>

                    </label>

                  </ng-container>


                  <!-- ============ CHECKER'S VIEW ============ -->
                  <!-- Maker's answer on the left, locked by validationForm.disable();
                       the checker's own answer on the right. -->
                  <div *ngIf="isChecker" class="vc-split">

                    <div class="vc-panel vc-panel-maker">

                      <h4 class="vc-panel-title">Maker Action</h4>

                      <div *ngIf="user.get('Error').value==='land'" class="vc-field">

                        <label class="vc-field-label">
                          Land Area (in acres)
                        </label>

                        <input
                          class="vc-input"
                          type="text"
                          formControlName="enteredLandArea"
                          placeholder="Not entered"
                          maxlength="4"
                        >

                      </div>

                      <label class="vc-confirm">

                        <input
                          type="checkbox"
                          class="vc-checkbox"
                          formControlName="isChecked"
                        >

                        <span>{{ getConfirmationText(user.get('label').value) }}</span>

                      </label>

                    </div>


                    <div class="vc-panel vc-panel-checker">

                      <h4 class="vc-panel-title">Checker Action</h4>

                      <div *ngIf="user.get('Error').value==='land'" class="vc-field">

                        <label class="vc-field-label">
                          Enter Land Area (in acres)
                        </label>

                        <input
                          class="vc-input"
                          type="text"
                          formControlName="checkerEnteredLandArea"
                          placeholder="e.g., 2.5"
                          maxlength="4"
                          (keypress)="allowOnlyNumberAndDecimal($event)"
                          (input)="validateLandAreaRange($event, user.get('checkerEnteredLandArea'))"
                        >

                      </div>

                      <label class="vc-confirm">

                        <input
                          type="checkbox"
                          class="vc-checkbox"
                          formControlName="checkerIsChecked"
                        >

                        <span>{{ getConfirmationText(user.get('label').value) }}</span>

                      </label>

                    </div>

                  </div>

                </div>

              </section>

            </div>


            <!-- ================= REMARKS ================= -->

            <!-- MAKER REMARKS -->
            <div *ngIf="!isChecker && !isReadOnlyRecord(i)" class="vc-field vc-remarks">

              <label class="vc-field-label">Remarks</label>

              <textarea
                formControlName="makerRemarks"
                rows="2"
                maxlength="300"
                placeholder="Add remarks for this land record..."
                class="vc-textarea"
              ></textarea>

            </div>

            <!-- Maker's remarks read-only beside the checker's own -->
            <div *ngIf="isChecker && !isReadOnlyRecord(i)" class="vc-split vc-remarks">

              <div class="vc-panel vc-panel-maker">
                <h4 class="vc-panel-title">Maker Remarks</h4>
                <p class="vc-readonly">{{applicant.get('makerRemarks').value || '—'}}</p>
              </div>

              <div class="vc-panel vc-panel-checker">
                <h4 class="vc-panel-title">Checker Remarks</h4>
                <textarea
                  formControlName="checkerRemarks"
                  rows="2"
                  maxlength="300"
                  placeholder="Add remarks for this land record..."
                  class="vc-textarea"
                ></textarea>
              </div>

            </div>


            <!-- ================= PER-RECORD ACTIONS ================= -->

            <div *ngIf="!isChecker && !isReadOnlyRecord(i)" class="vc-record-actions">

              <button
                class="vc-btn vc-btn-reject"
                type="button"
                (click)="rejectCard(i)"
                [disabled]="applicant.get('decision').value || isChecker"
              >
                Reject Record
              </button>

              <button
                class="vc-btn vc-btn-approve"
                type="button"
                (click)="approveCard(i)"
                [disabled]="!allChecked(i) || applicant.get('decision').value || isChecker"
              >
                Approve Record
              </button>

            </div>

            <!-- CHECKER'S OWN APPROVE / REJECT for this land record -->
            <div *ngIf="isChecker && !isReadOnlyRecord(i)" class="vc-record-actions">

              <button
                class="vc-btn vc-btn-reject"
                type="button"
                (click)="checkerRejectCard(i)"
                [disabled]="applicant.get('checkerDecision').value"
              >
                Reject Record
              </button>

              <button
                class="vc-btn vc-btn-approve"
                type="button"
                (click)="checkerApproveCard(i)"
                [disabled]="!allCheckerChecked(i) || applicant.get('checkerDecision').value"
              >
                Approve Record
              </button>

            </div>

          </section>

        </div>

      </div>


      <!-- ================= CUSTOMER'S CONSENT DOCUMENT (VIEW ONLY) =================
           Uploaded by the customer during their own journey, so it arrives on
           the application as a landConsentDocs entry with docType 'review' and
           is never editable here. Optional — the row is left out entirely when
           the customer uploaded nothing, for the maker and the checker alike. -->

      <div *ngIf="hasRecords() && customerConsentDoc()" class="vc-consent vc-consent-view">

        <div class="vc-consent-main">

          <span class="vc-doc-icon" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
            </svg>
          </span>

          <div class="vc-consent-text">

            <span class="vc-consent-label">
              Consent Document (PDF)
              <span class="vc-tag vc-tag-customer">Customer</span>
            </span>

            <span class="vc-consent-hint">
              View only
              <span *ngIf="customerConsentDoc().created">
                &middot; uploaded {{customerConsentDoc().created | date:'dd MMM yyyy, hh:mm a'}}
              </span>
            </span>

          </div>

        </div>

        <div class="vc-consent-controls">

          <button
            class="vc-btn vc-btn-view"
            type="button"
            (click)="viewConsentDoc(customerConsentDoc())"
            [disabled]="!!openingDocRef"
          >
            {{ openingDocRef === customerConsentDoc().referenceId ? 'Opening…' : 'View File' }}
          </button>

        </div>

      </div>


      <!-- ================= MAKER'S CONSENT DOCUMENT (VIEW ONLY, CHECKER) =================
           The checker uploads nothing — the maker's own document is already on
           the application by the time it reaches them, so it is shown the same
           read-only way as the customer's, distinguished only by its tag. -->

      <div *ngIf="isChecker && hasRecords() && makerConsentDoc()" class="vc-consent vc-consent-view">

        <div class="vc-consent-main">

          <span class="vc-doc-icon" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
            </svg>
          </span>

          <div class="vc-consent-text">

            <span class="vc-consent-label">
              Consent Document (PDF)
              <span class="vc-tag vc-tag-maker">Maker</span>
            </span>

            <span class="vc-consent-hint">
              View only
              <span *ngIf="makerConsentDoc().created">
                &middot; uploaded {{makerConsentDoc().created | date:'dd MMM yyyy, hh:mm a'}}
              </span>
            </span>

          </div>

        </div>

        <div class="vc-consent-controls">

          <button
            class="vc-btn vc-btn-view"
            type="button"
            (click)="viewConsentDoc(makerConsentDoc())"
            [disabled]="!!openingDocRef"
          >
            {{ openingDocRef === makerConsentDoc().referenceId ? 'Opening…' : 'View File' }}
          </button>

        </div>

      </div>


      <!-- ================= CONSENT DOCUMENT (MAKER UPLOAD) =================
           Required by /v1/mcu/makerconsent — a submit without it is rejected,
           so Proceed stays locked until a PDF is attached. One document for the
           whole application, hence it sits with the page actions and not inside
           a land record. Maker only: the checker has no upload of their own. -->

      <div
        *ngIf="!isChecker && hasReviewableRecords()"
        class="vc-consent vc-consent-upload"
        [class.vc-consent-attached]="consentFile"
      >

        <div class="vc-consent-main">

          <span class="vc-doc-icon" aria-hidden="true">

            <!-- Upload arrow until something is attached, then a tick -->
            <svg *ngIf="!consentFile" width="18" height="18" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="17 8 12 3 7 8"/>
              <line x1="12" y1="3" x2="12" y2="15"/>
            </svg>

            <svg *ngIf="consentFile" width="18" height="18" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>

          </span>

          <div class="vc-consent-text">

            <span class="vc-consent-label">
              Consent Document (PDF)
              <span class="vc-tag vc-tag-required" *ngIf="!consentFile">Required</span>
              <span class="vc-tag vc-tag-attached" *ngIf="consentFile">Attached</span>
            </span>

            <span *ngIf="!consentFile && !consentFileError" class="vc-consent-hint">
              Your upload &middot; PDF only &middot; up to 5MB
            </span>

            <span *ngIf="consentFile" class="vc-consent-file">
              {{consentFile.name}}
            </span>

            <span *ngIf="consentFileError" class="vc-consent-error" role="alert">
              {{consentFileError}}
            </span>

          </div>

        </div>

        <div class="vc-consent-controls">

          <input
            #consentInput
            type="file"
            class="vc-file-input"
            accept=".pdf"
            (change)="onConsentFileSelected($event)"
          >

          <!-- Loud while it is still the outstanding action, quiet once done -->
          <button
            class="vc-btn"
            [class.vc-btn-upload]="!consentFile"
            [class.vc-btn-close]="consentFile"
            type="button"
            (click)="consentInput.click()"
          >
            {{ consentFile ? 'Replace File' : 'Choose File' }}
          </button>

          <button
            *ngIf="consentFile"
            class="vc-btn vc-btn-link"
            type="button"
            (click)="removeConsentFile(consentInput)"
          >
            Remove
          </button>

        </div>

      </div>


      <!-- ================= PAGE ACTIONS ================= -->

      <div *ngIf="!isChecker && hasReviewableRecords()" class="vc-page-actions">

        <span class="vc-progress">
          {{decidedCount()}} of {{getApplicants().length}} records reviewed
        </span>

        <!-- No consent PDF, no submit — the API rejects it outright -->
        <button
          class="vc-btn vc-btn-proceed"
          type="button"
          (click)="makerProceedCard()"
          [disabled]="!allDecided() || checkerAction || !consentFile"
        >
          Proceed
        </button>

        <button
          class="vc-btn vc-btn-close"
          type="button"
          (click)="MakerClosedCard()"
        >
          Close
        </button>

      </div>

      <div *ngIf="isChecker && hasReviewableRecords()" class="vc-page-actions">

        <span class="vc-progress">
          {{decidedCount()}} of {{getApplicants().length}} records reviewed
        </span>

        <button
          class="vc-btn vc-btn-proceed"
          type="button"
          (click)="checkerProceedCard()"
          [disabled]="!allCheckerDecided() || checkerAction"
        >
          Proceed
        </button>

        <button
          class="vc-btn vc-btn-close"
          type="button"
          (click)="MakerClosedCard()"
        >
          Close
        </button>

      </div>

    </div>

  </div>

</form>
</div>
